//typeOfKey: 'dd/mm' ou 'timestamp' para ordenar conforme o tipo de chave
export const alignKeys = (typeOfKey, ...objects) => {
    // Filtrar objetos que têm pelo menos uma chave e valores dentro
    objects = objects.filter(obj => {
        const keyName = Object.keys(obj)[0];
        return keyName && Object.keys(obj[keyName] || {}).length > 0;
    });

    // Se não houver objetos válidos, retornar um array vazio
    if (objects.length === 0) {
        return { result: [], keys: [] };
    }

    // Inicializar o conjunto allKeys
    const allKeys = new Set();
    objects.forEach(obj => {
        const keyName = Object.keys(obj)[0];
        if (keyName) {
            Object.keys(obj[keyName] || {}).forEach(key => allKeys.add(key));
        }
    });

    // Converter o conjunto de chaves em um array ordenado
    var allKeysArray;
    if(typeOfKey === 'dd/mm'){
        allKeysArray = alignDayMonthKeys([...allKeys]);
    } else if(typeOfKey === 'dd/mm/yyyy'){
        allKeysArray = alignDayMonthYearKeys([...allKeys]);
    } else {
        allKeysArray = alignTimestampKeys([...allKeys]); 
    }

    // Ajustar todos os objetos para que tenham todas as chaves, com valores ou null
    const result = objects.map(obj => {
        const keyName = Object.keys(obj)[0];
        const newObj = { [keyName]: {} };

        // Preencher com valores ou null se a chave não existir
        allKeysArray.forEach(key => {
            newObj[keyName][key] = (obj[keyName] && obj[keyName][key] !== undefined)
                ? obj[keyName][key]
                : null;
        });

        return newObj;
    });

    return { result: result, keys: allKeysArray };
};

const alignDayMonthKeys = (keys) => {
    return keys.sort((a, b) => {
        // Converter a chave "dd/mm" em uma data para comparação
        const [dayA, monthA] = a.split('/').map(Number);
        const [dayB, monthB] = b.split('/').map(Number);

        // A comparação é feita com base no mês e no dia
        if (monthA === monthB) {
            return dayA - dayB; // Se os meses são iguais, compara os dias
        }
        return monthA - monthB; // Caso contrário, compara os meses
    });
};

const alignDayMonthYearKeys = (keys) => {
    return keys.sort((a, b) => {
        // Converter a chave "dd/mm/yyyy" em uma data para comparação
        const [dayA, monthA, yearA] = a.split('/').map(Number);
        const [dayB, monthB, yearB] = b.split('/').map(Number);

        // A comparação é feita com base no ano, mês e dia
        if (yearA === yearB) {
            if (monthA === monthB) {
                return dayA - dayB; // Se os anos e meses são iguais, compara os dias
            }
            return monthA - monthB; // Se os anos são iguais, compara os meses
        }
        return yearA - yearB; // Caso contrário, compara os anos
    }).map(date => {
        // Formatar a chave de volta para "dd/mm/yyyy"
        const [day, month, year] = date.split('/').map(Number);
        return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
    });
};

const alignTimestampKeys = (keys) => {
    return keys.sort((a, b) => a - b);
};